import React from "react"
import { sectionTitleStyle, dangerButtonStyle, primaryButtonStyle, successButtonStyle, warningButtonStyle } from "../styles/commonStyles"
import { checkPermission } from "../../../helper/functions"
import { TYPOGRAPHY } from "../constants/theme"
import User from "../../../libs/admin"

const SectionTitle = ({
	title,
	status,
	onDelete,
	onRefresh,
	onDebugLogin,
	onSubscribe,
	onUpdateExpiredPlan,
	showDeletePermission = "delete_enewspaper_customer",
	showSubscribePermission = "add_enewspaper_customer_plan",
	showDebugPermission = "debug_login",
	showUpdateExpiredPlanPermission = "add_enewspaper_customer_plan",
}) => {
	const user = User.getCookieData()

	const renderStatusBadge = () => {
		if (status === undefined) return null

		return (
			<div
				style={{
					display: "inline-flex",
					alignItems: "center",
					background: status ? "#e8f5e9" : "#ffebee",
					padding: "4px 10px",
					borderRadius: 20,
					fontWeight: 600,
					color: status ? "#2e7d32" : "#c62828",
					fontSize: TYPOGRAPHY.fontSize.sm,
					border: `1px solid ${status ? "#4caf50" : "#f44336"}`,
					marginLeft: 12,
				}}
			>
				<span
					style={{
						display: "inline-block",
						width: 12,
						height: 12,
						borderRadius: "50%",
						background: status ? "#2e7d32" : "#d32f2f",
						marginRight: 8,
					}}
				/>
				{status ? "Active" : "Expired"}
			</div>
		)
	}

	const renderActionButtons = () => {
		const buttons = []

		// Refresh Button
		if (onRefresh) {
			buttons.push(
				<button key="refresh" onClick={onRefresh} style={primaryButtonStyle} title="Refresh data">
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none" style={{ marginRight: 4 }}>
						<path
							d="M21 12c0 5-4 9-9 9s-9-4-9-9 4-9 9-9c2.9 0 5.5 1.4 7.1 3.5"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path d="M21 4v6h-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
					Refresh
				</button>
			)
		}

		// Subscribe Button
		if (onSubscribe && checkPermission(user.permission, showSubscribePermission)) {
			buttons.push(
				<button
					key="subscribe"
					onClick={onSubscribe}
					style={{
						...successButtonStyle,
						fontSize: TYPOGRAPHY.fontSize.sm,
						padding: "8px 16px",
						display: "flex",
						alignItems: "center",
						gap: "6px",
					}}
					title="Add new plan"
				>
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
						<path d="M12 5v14m-7-7h14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
					เพิ่มแพ็คเกจ
				</button>
			)
		}

		// Debug Login Button
		if (onDebugLogin && checkPermission(user.permission, showDebugPermission)) {
			buttons.push(
				<button
					key="debug"
					onClick={onDebugLogin}
					style={{
						...warningButtonStyle,
						fontSize: TYPOGRAPHY.fontSize.sm,
						padding: "8px 16px",
						display: "flex",
						alignItems: "center",
						gap: "6px",
					}}
					title="Debug login"
				>
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
						<path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
					Login
				</button>
			)
		}
		//
		// Update Expired Plan Button
		if (onUpdateExpiredPlan && process.env.REACT_APP_NODE_ENV === "development" && checkPermission(user.permission, showUpdateExpiredPlanPermission)) {
			buttons.push(
				<button
					key="updateExpiredPlan"
					onClick={onUpdateExpiredPlan}
					style={{
						...warningButtonStyle,
						fontSize: TYPOGRAPHY.fontSize.sm,
						padding: "8px 16px",
						display: "flex",
						alignItems: "center",
						gap: "6px",
					}}
					title="Update expired plan"
				>
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
						<path d="M4 12v8a2 2 0 002 2h12a2 2 0 002-2v-8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						<path d="M16 6l-4-4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
						<path d="M12 2v14" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					</svg>
					อัปเดตแพ็คเกจหมดอายุ
				</button>
			)
		}

		// Delete Button
		if (onDelete && (process.env.REACT_APP_NODE_ENV === "development" || checkPermission(user.permission, showDeletePermission))) {
			buttons.push(
				<button
					key="delete"
					onClick={onDelete}
					style={{
						...dangerButtonStyle,
						display: "flex",
						alignItems: "center",
						gap: "6px",
					}}
					title="Delete"
				>
					<svg width="16" height="16" viewBox="0 0 24 24" fill="none">
						<path
							d="M3 6h18m-2 0V20a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2M10 11v6M14 11v6"
							stroke="currentColor"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
					Delete
				</button>
			)
		}

		return buttons
	}

	return (
		<div
			className="section-title"
			style={{
				...sectionTitleStyle,
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				flexWrap: "wrap",
				gap: 12,
			}}
		>
			{/* Title and Status */}
			<div
				style={{
					display: "flex",
					alignItems: "center",
					gap: 12,
					flexWrap: "wrap",
				}}
			>
				<span
					style={{
						fontSize: TYPOGRAPHY.fontSize.xl,
						fontWeight: 700,
					}}
				>
					{title}
				</span>
				{renderStatusBadge()}
			</div>

			{/* Action Buttons */}
			<div
				style={{
					display: "flex",
					gap: 12,
					flexWrap: "wrap",
				}}
			>
				{renderActionButtons()}
			</div>
		</div>
	)
}

export default SectionTitle
